// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimePickerContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FloatAffixed from 'share/components/controls/Izenda.FloatAffixed';
import DateTimeCalendar from './Izenda.DateTimeCalendar';
import uiState from 'logic/Izenda.UiState';
import { getConfiguredMinMaxDateTime } from 'share/utils/Izenda.DateTimeUtils';
import Dimensions from 'share/components/hoc/Izenda.Dimensions';
import connect from 'share/enhancers/Izenda.Connect';

const DateTimePickerContainer = (props: any) => {
  const {
    calendar,
    time,
    hasRange,
    renderInContainer,
    disabled,
    pickerWidth,
    visible,
    hidePicker,
    anchor,
    calendarProps,
    className,
    children,
    pickerAsPopover
  } = props;
  const pickerClasses = classnames(className, 'izenda-DateTimePicker');
  const { MinDate, MaxDate } = getConfiguredMinMaxDateTime();

  const picker = (
    <DateTimeCalendar
      disabled={disabled}
      hasRange={hasRange}
      hasDate={calendar}
      hasTime={time}
      minDate={MinDate}
      maxDate={MaxDate}
      locale={uiState.currentUser.cultureName}
      {...calendarProps}
    />
  );

  return (
    <div className={pickerClasses}>
      {pickerAsPopover ? children : picker}
      {visible && pickerAsPopover && (
        <FloatAffixed
          anchor={anchor}
          onClickOutside={hidePicker}
          onParentScroll={hidePicker}
          autoWidth
          minWidth={pickerWidth}
          maxWidth={pickerWidth}
          renderInContainer={renderInContainer}
        >
          <DateTimeCalendar
            disabled={disabled}
            hasRange={hasRange}
            hasDate={calendar}
            hasTime={time}
            minDate={MinDate}
            maxDate={MaxDate}
            locale={uiState.currentUser.cultureName}
            {...calendarProps}
          />
        </FloatAffixed>
      )}
    </div>
  );
};

DateTimePickerContainer.propTypes = {
  time: PropTypes.bool,
  calendar: PropTypes.bool,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.object,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  multi: PropTypes.bool,
  hasRange: PropTypes.bool,
  renderInContainer: PropTypes.bool,
  pickerAsPopover: PropTypes.bool
};

export default connect(Dimensions)(DateTimePickerContainer);



// WEBPACK FOOTER //
// ./ui/share/components/controls/DateTime/Izenda.DateTimePickerContainer.js